import { FunctionComponent } from "react";

import { DEFAULT_OUTPUT_LANGUAGE } from "@signalist/shared-types";

import { SelectField } from "@/components/SelectField/SelectField";
import { outputLanguageOptions } from "@/constants/outputLanguages";

interface OutputLanguageSelectProps {
	label: string;
	value?: string | null;
	handleSelect: (languageCode: string) => void;
	disabled?: boolean;
}

/**
 * Shared "AI output language" dropdown (PREC-3485): the EU language set the AI
 * writes generated content in. A null/undefined value renders as English, the
 * historical default.
 */
export const OutputLanguageSelect: FunctionComponent<OutputLanguageSelectProps> = ({
	label,
	value,
	handleSelect,
	disabled,
}) => {
	return (
		<SelectField
			hideEmptyValue
			disabled={disabled}
			label={label}
			name="outputLanguage"
			options={outputLanguageOptions}
			selectedOption={value ?? DEFAULT_OUTPUT_LANGUAGE}
			handleSelect={(selected) => {
				if (typeof selected === "string") {
					handleSelect(selected);
				}
			}}
		/>
	);
};
